export default [
    {
        name: 'Pago',
        value: 'paid'
    },
    {
        name: 'Chargeback',
        value: 'chargeback'
    }
]